type Props = {
  mode: "create" | "edit"
  saving: boolean
  onCancel: () => void
}

export const PromotionEditorActions = ({ mode, saving, onCancel }: Props) => {
  return (
    <div className="flex justify-end gap-2 pt-4">
      <button type="button" className="btn btn-ghost" onClick={onCancel}>
        Cancel
      </button>
      <button type="submit" className="btn btn-primary" disabled={saving}>
        {mode === "create" ? "Create" : "Save changes"}
      </button>
    </div>
  )
}
